import { Plus } from '@phosphor-icons/react/dist/ssr/Plus';
import { IconCircleButton } from './Icons/IconCircleButton';
import { COLORS } from '../../styles/UISystem';

/**
 * AddCircleButton — the standard "add" affordance: a circular + button with an
 * optional very-light-grey label. Used for adding groups, contacts, etc. so every
 * add control looks and behaves the same.
 *
 * @param {string} label - Label text (e.g. "Add group", "Add contact")
 * @param {boolean} showLabel - Whether to show the label (default true). Groups hide
 *   it once at least one chip is present; contacts always show it.
 * @param {boolean} emphasized - Filled dark-grey circle + white plus + medium dark
 *   label (SP profile page's "Share another" — user mock 2026-08-08). Default keeps
 *   the light treatment every other add site uses.
 * @param {function} onClick - Click handler
 * @param {object} [style] - Optional wrapper style (e.g. left padding to align with rows)
 */
const AddCircleButton = ({ label, showLabel = true, emphasized = false, onClick, style }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      ...style,
    }}
  >
    <IconCircleButton
      icon={Plus}
      buttonSize={36}
      size={18}
      backgroundColor={emphasized ? COLORS.DARK_GRAY : undefined}
      iconColor={emphasized ? 'white' : '#C7C7CC'}
      iconWeight={emphasized ? 'bold' : 'regular'}
    />
    {showLabel && label && (
      <span
        style={{
          fontSize: '16px',
          fontWeight: emphasized ? 500 : 300,
          color: emphasized ? COLORS.DARK_GRAY : '#C7C7CC',
        }}
      >
        {label}
      </span>
    )}
  </button>
);

export default AddCircleButton;
